import gql from 'graphql-tag'
import { productGrid } from '../fragments'

export default gql`
	mutation upsertProducts($records: [NewProduct!]!) {
		cashAssist {
			upsertProducts(records: $records) {
				...productGrid
			}
		}
	}
${productGrid}`
